import { useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { logger } from '../utils/logger';

const usePossessUser = (defaultUserId?: string) => {
  const queryClient = useQueryClient();
  const [userId, setUserId] = useState(defaultUserId);

  useEffect(() => {
    if (!userId) return;

    const possess = async () => {
      window.localStorage.setItem('impersonate-user-id', userId);

      queryClient.clear();

      window.location.href = '/';
    };
    possess().catch((e) => logger.error('Error possessing user:', e));
  }, [userId]);

  return { setPossessedUserId: setUserId };
};

export default usePossessUser;
